var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import ClientService from '../../../api/ClientService';
import { Loading } from 'element-ui';
import Pagination from "../../../common/components/Pagination.vue";
var LogisticsManageDialog = (function (_super) {
    __extends(LogisticsManageDialog, _super);
    function LogisticsManageDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.searchKeyword = '';
        _this.clientDetail = '';
        _this.dialogVisible = false;
        _this.dialogType = 'add';
        _this.formData = {
            logistics_id: '',
            logistics_name: ''
        };
        _this.formRules = {
            logistics_name: [
                { required: true, message: '请输入物流名称', trigger: 'blur' },
                { max: 50, message: '物流名称最多50个字符', trigger: 'blur' }
            ]
        };
        return _this;
    }
    LogisticsManageDialog.prototype.created = function () {
        this.service = ClientService.getInstance();
    };
    LogisticsManageDialog.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            if (_this.clientDetail && _this.clientDetail.business_id) {
                _this.getLogisticsList();
            }
        });
    };
    LogisticsManageDialog.prototype.getLogisticsList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20, is_page: 1 }; }
        if (!this.clientDetail || !this.clientDetail.business_id) {
            this.$message.error('客户信息获取失败');
            return;
        }
        var params = Object.assign({
            business_id: this.clientDetail.business_id,
            keyword: this.searchKeyword
        }, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getLogisticList(params).then(function (res) {
            if (res.data.success) {
                _this.listData = Array.isArray(res.data.data.data) ? res.data.data.data : [];
                _this.total = res.data.data.total || 0;
            }
            else {
                _this.$message.error(res.data.msg);
            }
            loadingInstance.close();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
            loadingInstance.close();
        });
    };
    LogisticsManageDialog.prototype.pageChange = function (pager) {
        this.getLogisticsList(pager);
    };
    LogisticsManageDialog.prototype.search = function () {
        this.getLogisticsList();
    };
    LogisticsManageDialog.prototype.openAddDialog = function () {
        this.dialogType = 'add';
        this.formData = {
            logistics_id: '',
            logistics_name: ''
        };
        this.dialogVisible = true;
    };
    LogisticsManageDialog.prototype.openEditDialog = function (row) {
        this.dialogType = 'edit';
        this.formData = {
            logistics_id: row.logistics_ids,
            logistics_name: row.logistics_name
        };
        this.dialogVisible = true;
    };
    LogisticsManageDialog.prototype.saveForm = function () {
        var _this = this;
        if (!this.clientDetail || !this.clientDetail.business_id) {
            this.$message.error('客户信息获取失败');
            return;
        }
        this.$refs.form.validate(function (valid) {
            if (valid) {
                var params = {
                    business_id: _this.clientDetail.business_id,
                    logistics_name: _this.formData.logistics_name
                };
                var promise = void 0;
                if (_this.dialogType === 'add') {
                    promise = _this.service.createLogistics(params);
                }
                else {
                    promise = _this.service.updateLogistics(__assign({}, params, { logistics_id: _this.formData.logistics_id }));
                }
                promise.then(function (res) {
                    if (res.data.success) {
                        _this.$message.success('保存成功！');
                        _this.dialogVisible = false;
                        var pager = _this.$refs.pagination.pager;
                        pager.is_page = 1;
                        _this.getLogisticsList(pager);
                        _this.$emit('refresh:ok');
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                }).catch(function (err) {
                    _this.$message.error(err.msg || err.message);
                });
            }
        });
    };
    LogisticsManageDialog.prototype.deleteItem = function (row) {
        var _this = this;
        this.$confirm('确定要删除该物流吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(function () {
            _this.service.deleteLogistics({
                logistics_ids: row.logistics_ids
            }).then(function (res) {
                if (res.data.success) {
                    _this.$message.success('删除成功！');
                    _this.getLogisticsList(_this.$refs.pagination.pager);
                    _this.$emit('refresh:ok');
                }
                else {
                    _this.$message.error(res.data.msg);
                }
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }).catch(function () {
        });
    };
    LogisticsManageDialog.prototype.close = function () {
        this.$closeDialog();
    };
    LogisticsManageDialog = __decorate([
        Component({
            components: {
                'pagination': Pagination
            }
        })
    ], LogisticsManageDialog);
    return LogisticsManageDialog;
}(VueDialog));
export default LogisticsManageDialog;
